import {CareTask} from '../../backend/interfaces/care-task';
import {EntitySocialResponse} from '../../backend/interfaces/entity-social-response';
import {EntityPendingTask} from '../../backend/interfaces/entity-pending-task';
import {EntityOccurrenceType} from '../../backend/responses/entity-occurrence';

export interface EntityContextState {
  availableSocialResponses: EntitySocialResponse[];
  userEntitySocialResponses: EntitySocialResponse[];
  pendingTasks: {pendingCareTask: EntityPendingTask; careTask: CareTask}[];
  occurrencesCount: number;
  occurrencesTypes?: EntityOccurrenceType[];
}

export enum EntityContextActionType {
  UPDATE_AVAILABLE_ENTITY_SOCIAL_RESPONSES = 'UPDATE_AVAILABLE_ENTITY_SOCIAL_RESPONSES',
  UPDATE_USER_ENTITY_SOCIAL_RESPONSES = 'UPDATE_USER_ENTITY_SOCIAL_RESPONSES',
  UPDATE_ENTITY_PENDING_TASKS = 'UPDATE_ENTITY_PENDING_TASKS',
  UPDATE_ENTITY_OCCURRENCES_COUNT = 'UPDATE_ENTITY_OCCURRENCES_COUNT',
  UPDATE_ENTITY_OCCURRENCES_TYPES = 'UPDATE_ENTITY_OCCURRENCES_TYPES',
}

export type EntityContextAction =
  | {
      type: EntityContextActionType.UPDATE_AVAILABLE_ENTITY_SOCIAL_RESPONSES;
      availableSocialResponses: EntitySocialResponse[];
    }
  | {
      type: EntityContextActionType.UPDATE_USER_ENTITY_SOCIAL_RESPONSES;
      userEntitySocialResponses: EntitySocialResponse[];
    }
  | {
      type: EntityContextActionType.UPDATE_ENTITY_PENDING_TASKS;
      pendingTasks: {pendingCareTask: EntityPendingTask; careTask: CareTask}[];
    }
  | {
      type: EntityContextActionType.UPDATE_ENTITY_OCCURRENCES_COUNT;
      occurrencesCount: number;
    }
  | {
      type: EntityContextActionType.UPDATE_ENTITY_OCCURRENCES_TYPES;
      occurrencesTypes: EntityOccurrenceType[];
    };

export interface EntityContextType {
  state: EntityContextState;
  updateUserEntitySocialResponses: (socialResponseIds: string[]) => void;
  updateEntityPendingTasks: () => Promise<void>;
  updateEntityOccurrencesCount: () => Promise<void>;
  updateEntityOccurrencesTypes: () => Promise<void>;
}
